<template>
  <figure class="picture" :data-anim="isLazy ? 'picture' : isLazy">
    <img
      class="picture__img"
      :src="!isLazy ? data.src : !isLazy"
      :data-src="isLazy ? data.src : isLazy"
      :alt="data.alt"
    >
    <div
      :style="{
        backgroundImage: isLazy ? !isLazy : `url(${data.src})`,
      }"
      class="picture__div-img"
    ></div>
  </figure>
</template>

<script>
export default {
  name: 'AppFigure',

  props: {
    data: {
      type: Object,
      required: true,
    },

    isLazy: {
      type: Boolean,
      required: false,
      default: true,
    },
  },
};
</script>

<style lang="scss" scoped>
.picture {
  position: relative;

  &__div-img {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;

    background-size: cover;
    background-position: center center;
    background-repeat: no-repeat;
  }

  &__img {
    display: block;

    position: relative;
    width: 100%;
    max-width: 100%;
    height: auto;

    position: absolute;
    overflow: hidden;
    clip: rect(0 0 0 0);
    width: 1px;
    height: 1px;
    margin: -1px;
    padding: 0;
    border: 0;
  }
}
</style>
